import React from "react";
import "./ManagedServices.css";

function ManagedServices() {
  return (
    <>
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb10">
        <div className="bg-breadcrumb-single" />
        <div className="container text-center py-5" style={{ maxWidth: 900 }}>
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Managed Services
          </h4>
        </div>
      </div>
      {/* Header End */}

      {/* Body Start */}
      <section className="container section-padding" id="portfolio">
        {/* Services Grid */}
        <div className="row text-center mb-5">
          <div className="col-12">
            <h2 className="section-title wow zoomIn">Our Managed Services</h2>
          </div>
        </div>

        <div className="row g-4">
          {[
            {
              img: "assets/img/onshore.png",
              title: "Optimization and Reporting",
            },
            {
              img: "assets/img/it-automation.png",
              title: "IT Automation",
            },
            {
              img: "assets/img/priority-support.png",
              title: "Priority Support",
            },
            {
              img: "assets/img/network.png",
              title: "Full Network Maintenance",
            },
            {
              img: "assets/img/documentation.png",
              title: "ERP Solutions (SAP and Oracle)",
            },
            {
              img: "assets/img/it-consulting.png",
              title: "IT Consulting & Strategy",
            },
          ].map((service, index) => (
            <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
              <div className="card service-card h-100 wow fadeInUp">
                <div className="card-body text-center">
                  <div className="icon-wrapper">
                    <img
                      src={service.img}
                      alt={service.title}
                      className="service-icon"
                    />
                  </div>
                  <h5 className="card-title mt-3">{service.title}</h5>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Elements Section */}
        <div className="row mt-5">
          <div className="col-12">
            <h3 className="mb-4">Elements of our Managed Services Practice</h3>
            <div className="elements-list">
              {[
                {
                  title: "Proactive Monitoring and Maintenance",
                  desc: "Continuous system oversight to identify and resolve issues before they impact operations.",
                },
                {
                  title: "Service Level Agreements (SLAs)",
                  desc: "Clearly defined metrics ensuring accountability and meeting client performance expectations.",
                },
                {
                  title: "Scalable Infrastructure Management",
                  desc: "Flexible solutions that adapt to evolving business demands and growth.",
                },
                {
                  title: "Comprehensive Support Services",
                  desc: "24/7 helpdesk, troubleshooting, and end-user support to ensure seamless operations.",
                },
                {
                  title: "Expertise in Multi-Vendor Environments",
                  desc: "Integration and management of diverse technologies across platforms.",
                },
                {
                  title: "Continuous Optimization and Reporting",
                  desc: "Regular performance analysis, cost efficiency assessments, and system upgrades for ongoing improvement.",
                },
              ].map((el, idx) => (
                <div className="element-card shadow-sm" key={idx}>
                  <div className="element-badge">{idx + 1}</div>
                  <div>
                    <h5>{el.title}</h5>
                    <p>{el.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Support & Industries */}
        <div className="row mt-5 g-4">
          <div className="col-lg-6 col-md-12">
            <div className="info-box h-100 shadow-lg rounded wow fadeInLeft">
              <h4>Managed Services Support</h4>
              <ul>
                <li>Framework for knowledge management</li>
                <li>Methodologies and artifacts for accelerated execution</li>
                <li>Infrastructure for solution evaluation and pre-validation</li>
                <li>Implementation of best practices for scalable solutions</li>
                <li>Network Security</li>
                <li>Cyber Security & Compliance</li>
                <li>24/7 Monitoring and Maintenance</li>
                <li>Helpdesk and Technical Support</li>
                <li>Cloud and Infrastructure Management</li>
              </ul>
            </div>
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="info-box h-100 shadow-lg rounded wow fadeInRight">
              <h4>Industries Supported</h4>
              <ul>
                <li>Banking, Mortgage and Insurance</li>
                <li>Wireless, Telecommunications & Media</li>
                <li>Hi-tech & Manufacturing</li>
                <li>Logistics & Supply chain</li>
                <li>Pharmaceuticals</li>
                <li>Life Sciences & Healthcare</li>
                <li>Oil and gas</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Body End */}



      
   {/* Footer */}
      <div className="container-fluid footer wow fadeIn" data-wow-delay="0.2s">
        <div className="container pt-4">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>USA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> 1500 S Dairy Ashford Rd <br /> Ste 355 Houston, TX 77077</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><em><span style={{ fontSize: 20 }}><strong>CANADA</strong></span></em></p>
              <p><i className="fas fa-map-marker me-1" /> 998 Loft Court, London, Ontario, N6G0J9</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>INDIA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> D. No. 38, 2nd Floor, Arjun Plaza, SP Road, Nizampet, Hyderabad, Telangana - 500085</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <a href="mailto:info@celersoft.com"><i className="fas fa-envelope me-2" /> info@celersoft.com</a>
                <a href="tel:+18322258898"><i className="fas fa-phone me-2" /> (+1) 832-225-8898</a>
                <hr />
                <div className="d-flex align-items-center">
                  <a className="btn btn-light btn-md-square me-2" href="https://www.facebook.com/celersoft">
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a className="btn btn-light btn-md-square me-0" href="https://www.linkedin.com/company/celersoft/">
                    <i className="fab fa-linkedin-in" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

  <div className="container-fluid copyright py-3">
          <div className="container">
            <div className="row g-4 align-items-center">
              <div className="col-md-6 text-center text-md-start mb-md-0">
                <span className="text-body">
                  <i className="fas fa-copyright text-light me-1" />
                  2024 Celersoft. All rights reserved.
                </span>
              </div>
              {/* <div className="col-md-6 text-center text-md-end text-body">
              <a
                    className="border-bottom text-primary"
                    href="https://htmlcodex.com"
                >
                    HTML Codex
                </a>{" "}
                Distributed By{" "}
                <a
                    className="border-bottom text-primary"
                    href="https://themewagon.com"
                >
                    ThemeWagon
                </a>


              </div> */}
            </div>
          </div>
        </div>
  {/* <a href="/Erp" className="btn btn-primary btn-lg-square back-to-top">
          <i className="fa fa-arrow-up" />
        </a> */}

<button
  className="btn btn-primary btn-lg-square back-to-top"
  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
>
  <i className="fa fa-arrow-up" />
</button>

        
    </>


  );

  
}

export default ManagedServices;
